// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortcutKeysPanelRnd {
  position: fixed !important;
  z-index: 1001;
}
.shortcutResizeIndicator {
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  display: inline-flex;
  position: absolute;
  padding-right: 4px;
  padding-bottom: 4px;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;
}
.shortcutResizeIndicator .anticon {
  width: 10px;
  height: 10px;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.shortcutResizeIndicator .svg-class {
  width: 10px;
  height: 10px;
}
.shortcutKeysPanelRnd .shortcutResizeHandleSe {
  right: 0px;
  bottom: 0px;
  width: 12px;
  height: 12px;
  z-index: 3;
  cursor: nwse-resize;
  background: transparent;
  position: absolute;
}
.shortcutKeysPanelRnd .shortcutResizeHandleSe::after {
  display: none;
}
.shortcutKeysPanel {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 8px;
  background: #282828;
  color: #f5f5f5;
  padding: 9px 16px 14px 16px;
  box-sizing: border-box;
  font-size: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.shortcutHeader {
  min-height: 24px;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 6px;
  align-items: center;
  justify-content: space-between;
  cursor: move;
}
.shortcutHeader button {
  position: absolute;
  right: 11px;
  top: 11px;
  width: 18px;
  height: 18px;
  border: 0;
  color: #bcbcbc;
  cursor: pointer;
  line-height: 1;
  border-radius: 2px;
  background: transparent;
  text-align: center;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.shortcutHeader button:hover {
  color: #ffffff;
  background: #4c4c4c;
}
.shortcutHeader .anticon {
  width: 10px;
  height: 10px;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.shortcutHeader .svg-class {
  min-width: 10px;
  width: 10px;
  height: 10px;
  display: block;
}
.shortcutTabs {
  width: fit-content;
  height: 32px;
  gap: 1px;
  display: flex;
  margin-bottom: 6px;
  border: 1px solid #707070;
  border-radius: 4px;
  overflow: hidden;
  align-self: flex-start;
  box-sizing: border-box;
}
.shortcutTabs button {
  width: auto;
  min-width: 32px;
  height: 30px;
  padding: 0 8px;
  border: 0;
  color: #f2f2f2;
  cursor: pointer;
  background: transparent;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  border-radius: 3px;
}
.shortcutTabs .active {
  background: #5c5c5c;
}
.shortcutTable {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.shortcutTableHeader,
.shortcutTableRow {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.shortcutTableRow {
  height: 35px;
  overflow: hidden;
}
.shortcutTableRow:nth-child(odd) {
  background: rgba(92, 92, 92, 0.2);
}
.shortcutTableRow:nth-child(even) {
  background: rgba(127, 127, 127, 0.2);
}
.shortcutTableRow > span {
  height: 100%;
}
.shortcutTableRow > div {
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  height: 100%;
  overflow: hidden;
}
.shortcutTableHeader {
  height: 30px;
  min-height: 30px;
  font-weight: 700;
  font-size: 14px;
  border: 1px solid #8A8F98;
  border-radius: 4px 4px 0 0;
  background: rgba(255, 255, 255, 0.05);
}
.shortcutTableHeader span {
  padding: 0 12px;
  display: flex;
  align-items: center;
}
.shortcutTableScrollView {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}
.shortcutTableContentPanel {
  width: 100%;
  border: 1px solid #8a8f98;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
}
.shortcutTableHeader > span:first-child {
  padding: 0 12px;
  text-align: left;
}
.shortcutTableHeader > span:nth-child(2),
.shortcutTableHeader > span:nth-child(3) {
  padding: 0 8px;
  text-align: left;
}
.shortcutKeyGroup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.shortcutKeyCapsule {
  min-width: 20px;
  height: 20px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #f9fafb;
  color: #374151;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  box-sizing: border-box;
}
.shortcutKeyPlus {
  color: #e1e1e1;
  line-height: 1;
}
.shortcutTableScrollView::-webkit-scrollbar {
  width: 8px;
}
.shortcutTableScrollView::-webkit-scrollbar-track {
  background: #686868;
}
.shortcutTableScrollView::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/ShortcutKeysView/index.less"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,aAAA;AACF;AAEA;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;AAGA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAIA;EACE,WAAA;EACA,YAAA;AAFF;AAMA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAJF;AAOA;EACE,aAAA;AALF;AAQA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AANF;AASA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAPF;AADA;EAWI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;AASI;EACE,cAAA;EACA,mBAAA;AAPN;AAvBA;EAmCI,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AATJ;AA/BA;EA4CI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAVJ;AAcA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAZF;AAEA;EAaI,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAZJ;AAZA;EA4BI,mBAAA;AAbJ;AAiBA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAfF;AAkBA;;EAEE,aAAA;EACA,kCAAA;AAhBF;AAmBA;EACE,YAAA;EACA,gBAAA;AAjBF;AAkBE;EACE,iCAAA;AAhBJ;AAkBE;EACE,oCAAA;AAhBJ;AAoBA;EACE,YAAA;AAlBF;AAqBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAnBF;AAsBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,qCAAA;AApBF;AAaA;EAUI,eAAA;EACA,aAAA;EACA,mBAAA;AApBJ;AAwBA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAtBF;AAyBA;EACE,WAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AAvBF;AA0BA;EACE,eAAA;EACA,gBAAA;AAxBF;AA2BA;;EAEE,cAAA;EACA,gBAAA;AAzBF;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA9BF;AAiCA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AA/BF;AAkCA;EACE,cAAA;EACA,cAAA;AAhCF;AAmCA;EACE,UAAA;AAjCF;AAoCA;EACE,mBAAA;AAlCF;AAqCA;EACE,mBAAA;EACA,kBAAA;AAnCF","sourcesContent":[".shortcutKeysPanelRnd {\n  position: fixed !important;\n  z-index: 1001;\n}\n\n.shortcutResizeIndicator {\n  right: 0;\n  bottom: 0;\n  width: 14px;\n  height: 14px;\n  display: inline-flex;\n  position: absolute;\n  padding-right: 4px;\n  padding-bottom: 4px;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  pointer-events: none;\n}\n\n.shortcutResizeIndicator .anticon {\n  width: 10px;\n  height: 10px;\n  line-height: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.shortcutResizeIndicator .svg-class {\n  width: 10px;\n  height: 10px;\n\n}\n\n.shortcutKeysPanelRnd .shortcutResizeHandleSe {\n  right: 0px;\n  bottom: 0px;\n  width: 12px;\n  height: 12px;\n  z-index: 3;\n  cursor: nwse-resize;\n  background: transparent;\n  position: absolute;\n}\n\n.shortcutKeysPanelRnd .shortcutResizeHandleSe::after {\n  display: none;\n}\n\n.shortcutKeysPanel {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  border-radius: 8px;\n  background: #282828;\n  color: #f5f5f5;\n  padding: 9px 16px 14px 16px;\n  box-sizing: border-box;\n  font-size: 12px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.shortcutHeader {\n  min-height: 24px;\n  display: flex;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 6px;\n  align-items: center;\n  justify-content: space-between;\n  cursor: move;\n\n  button {\n    position: absolute;\n    right: 11px;\n    top: 11px; \n    width: 18px;\n    height: 18px;\n    border: 0;\n    color: #bcbcbc;\n    cursor: pointer;\n    line-height: 1;\n    border-radius: 2px;\n    background: transparent;\n    text-align: center;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      color: #ffffff;\n      background: #4c4c4c;\n    }\n  }\n\n  .anticon {\n    width: 10px;\n    height: 10px;\n    line-height: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .svg-class {\n    min-width: 10px;\n    width: 10px;\n    height: 10px;\n    display: block;\n  }\n}\n\n.shortcutTabs {\n  width: fit-content;\n  height: 32px;\n  gap: 1px;\n  display: flex;\n  margin-bottom: 6px;\n  border: 1px solid #707070;\n  border-radius: 4px;\n  overflow: hidden;\n  align-self: flex-start;\n  box-sizing: border-box;\n\n  button {\n    width: auto;\n    min-width: 32px;\n    height: 30px;\n    padding: 0 8px;\n    border: 0;\n    color: #f2f2f2;\n    cursor: pointer;\n    background: transparent;\n    font-weight: 700;\n    font-size: 14px;\n    white-space: nowrap;\n    border-radius: 3px\n  }\n\n  .active {\n    background: #5c5c5c;\n  }\n}\n\n.shortcutTable {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.shortcutTableHeader,\n.shortcutTableRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.shortcutTableRow {\n  height: 35px;\n  overflow: hidden;\n  &:nth-child(odd) {\n    background: rgba(92, 92, 92, 0.2);\n  }\n  &:nth-child(even) {\n    background: rgba(127, 127, 127, 0.2);\n  }\n}\n\n.shortcutTableRow > span {\n  height: 100%\n}\n\n.shortcutTableRow > div {\n  padding: 4px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 3px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.shortcutTableHeader {\n  height: 30px;\n  min-height: 30px;\n  font-weight: 700;\n  font-size: 14px;\n  border: 1px solid #8A8F98;\n  border-radius: 4px 4px 0 0;\n  background: rgba(255, 255, 255, 0.05);\n\n  span {\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.shortcutTableScrollView {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0;\n}\n\n.shortcutTableContentPanel {\n  width: 100%;\n  border: 1px solid #8a8f98;\n  border-top: 0;\n  border-radius: 0 0 4px 4px;\n  overflow: hidden;\n}\n\n.shortcutTableHeader > span:first-child {\n  padding: 0 12px;\n  text-align: left;\n}\n\n.shortcutTableHeader > span:nth-child(2),\n.shortcutTableHeader > span:nth-child(3) {\n  padding: 0 8px;\n  text-align: left;\n}\n\n.shortcutActionName {\n  // styles applied inline\n}\n\n.shortcutKeyGroup {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.shortcutKeyCapsule {\n  min-width: 20px;\n  height: 20px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: #f9fafb;\n  color: #374151;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  box-sizing: border-box;\n}\n\n.shortcutKeyPlus {\n  color: #e1e1e1;\n  line-height: 1;\n}\n\n.shortcutTableScrollView::-webkit-scrollbar {\n  width: 8px;\n}\n\n.shortcutTableScrollView::-webkit-scrollbar-track {\n  background: #686868;\n}\n\n.shortcutTableScrollView::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
